/** Published passport snapshot from platform DPP (immutable version JSON). */
export interface PublishedSnapshot {
  passportId: string;
  passportNumber: string;
  uniqueIdentifier: string;
  versionNumber?: number;
  publishedAt?: string;
  locale?: string;
  availableLocales?: string[];
  identifiers?: {
    product?: string;
    operator?: string;
    facility?: string;
    registration?: string;
    commodityCode?: string;
    passportType?: string;
    model?: string;
    batch?: string;
  };
  template?: { id?: string; name?: string; code?: string };
  sections?: Array<{
    name: string;
    visibility?: string;
    fields?: Array<{
      name: string;
      label: string;
      value: unknown;
      visibility?: string;
      isRegulatoryMandatory?: boolean;
      isVoluntary?: boolean;
    }>;
  }>;
  evidence?: Array<{
    name: string;
    type?: string;
    url?: string;
    visibility?: string;
  }>;
  branding?: {
    organisation_name?: string | null;
    logo_url?: string | null;
    primary_color?: string | null;
  };
  product?: Record<string, unknown>;
  lifecycle?: Array<{
    type: string;
    description?: string | null;
    at: string;
    source?: string;
  }>;
}

export function isPublishedSnapshot(data: unknown): data is PublishedSnapshot {
  if (!data || typeof data !== 'object') return false;
  const d = data as Record<string, unknown>;
  return Array.isArray(d.sections) && typeof d.uniqueIdentifier === 'string';
}
